import { Filters } from "components/custom"
import { leadsToDoTags, leadTypes } from "constants/list"
import { getTaskSource } from "constants/list"
import { useGetStaffHierarchyQuery, useGetRecruitmentDriveQuery, useGetClassificationQuery, useGetMeetingPushedStagesQuery } from "features/shared/api"
import { useGetTodosProjectQuery } from "features/todos/api"
import { t } from "i18next"
import { useSelector } from "react-redux"

const { useMemo } = require("react")

export default function TodosFilters({ isFetchingTodos, filtersRef }) {
  const user = useSelector(state => state?.app?.user?.info)

  const {
    data: assigneeList,
    isFetching,
    isLoading,
  } = useGetStaffHierarchyQuery({
    userId: user?.id,
    module: "leads",
    subModule: "searchTodoLeads",
  })
  const { data: todosProjects, isLoading: isTodosProjectFetching } = useGetTodosProjectQuery()
  const { data: recruitmentDriveData, isFetching: recruitmentDriveLoading } = useGetRecruitmentDriveQuery()
  const { data: classifications } = useGetClassificationQuery()
  const { data: meetingPushedStages, isFetching: isFetchingMeetingStages } =
  useGetMeetingPushedStagesQuery("todos")

  const sharingTypes = useMemo(
    () => [
      { label: t("Allocated Leads"), value: "allocatedLeads" },
      { label: t("Shared Leads"), value: "sharedLeads" },
      { label: t("Shared with Telesales"), value: "sharedWithTelesales" },
    ],
    []
  )
  
  // TODO: need to change these values

  const taskTypes = useMemo(
    () => [
      { label: t("Arrange Meeting"), value: `Arrange Meeting` },
      { label: t("Contact Client"), value: `Contact Client` },
      { label: t("Follow Up"), value: `Follow Up` },
      { label: t("Meet Client"), value: `Meet Client` },
      { label: t("Receive Token Payment"), value: `Receive Token Payment` },
      { label: t("Receive Partial Down Payment"), value: `Receive Partial Down Payment` },
      { label: t("Receive Complete Down Payment"), value: `Receive Complete Down Payment` },
      { label: t("Sign Sale Agreement"), value: `Sign Sale Agreement` },
      { label: t("Sign Booking Form"), value: `Sign Booking Form` },
    ],

    []
  )
  
  const filterList = useMemo(() => {
    return [
      {
        type: "unitSelect",
        label: t("Search By"),
        keyList: [
          { label: t("Lead ID"), value: "inquiryId" },
          { label: t("Client ID"), value: "clientId" },
          { label: t("Cell No"), value: "clientCell" },
        ],
        maxCharacterLength: 2100,
      },
      {
        label: t("Assigned Staff"),
        list: assigneeList,
        type: "treeSelect",
        key: "assignedTo",
        toggle: { key: "assignedTo_withoutChildren", label: t("Include Team") },
        placeholder: t("Search by Task Added By"),
        appliedFilter: { searchKey: "userIds", responseKey: "users", duplicate: true },
      },

      {
        label: t("ToDo Type"),
        list: taskTypes,
        type: "select",
        mode: "multiple",
        key: "nextTask",
        placeholder: t("Search by ToDo Type"),
        appliedFilter: { type: "static-list" },
      },
      {
        label: t("Show To Do's For"),
        list: sharingTypes,
        type: "select",
        key: "ownerTaskType",
        placeholder: t("Search To Do's For"),
        appliedFilter: { type: "static-list" },
      },
      {
        type: "dateRange",
        label: t("Todo Deadline"),
        key: "deadline",
        appliedFilter: { type: "date" },
      },
      {
        label: t("Lead Classification"),
        type: "select",
        list: classifications,
        key: "leadClassificationIds",
        placeholder: t("Search by Lead Classification"),
        mode: "multiple",
        appliedFilter: { type: "static-list" },
      },
      {
        label: t("ToDo Tag"),
        list: leadsToDoTags(),
        type: "select",
        key: "tag",
        placeholder: t("Search by ToDo Tag"),
        appliedFilter: { type: "static-list" },
      },
      {
        label: t("Meeting Pushed Status"),
        list: meetingPushedStages,
        type: "select",
        key: "meetingPushedStageIds",
        mode: "multiple",
        placeholder: t("Search by Meeting Pushed Status"),
        inputLoading: isFetchingMeetingStages,
        appliedFilter: { searchKey: "meetingPushedStageIds", responseKey: "meetingPushedStages" },
      },
      {
        label: t("By Project"),
        list: todosProjects,
        type: "select",
        mode: "multiple",
        key: "projectId",
        placeholder: t("Search by Project"),
        appliedFilter: { type: "static-list" },
      },
      {
        label: t("Search By Recruitment Drive"),
        list: recruitmentDriveData,
        type: "select",
        key: "labelId",
        mode: "multiple",
        placeholder: t("Search by Recruitment Drive"),
        inputLoading: recruitmentDriveLoading,
        appliedFilter: { searchKey: "labelIds", responseKey: "userLabels" },
      },
      {
        label: t("Task Source"),
        list: getTaskSource(),
        type: "select",
        key: "source",
        placeholder: t("Search Task Source"),
        appliedFilter: { type: "static-list" },
      },
      {
        label: t("Lead Type"),
        type: "select",
        list: leadTypes(),
        key: "interestedIn",   
        placeholder: t("Search by Lead Type"),
        appliedFilter: { type: "static-list" },
      },
    ]
  }, [sharingTypes, taskTypes, assigneeList, todosProjects, recruitmentDriveData, recruitmentDriveLoading, classifications])

  return (
    <Filters
      list={filterList || []}
      ref={filtersRef}
      isFetching={isFetchingTodos}
      loading={isFetching}
      skeletonLoading={isLoading}
    />
  )
}
